import { useTheme } from '@flik/shared/components';
import React from 'react';
import { HeaderProps } from '../types';

const NotFoundHeader: React.FC<HeaderProps> = () => {
  const { provideTailwind } = useTheme();

  return (
    <div className="flex items-center justify-center w-full">
      <h1
        className={`text-xl font-semibold ${provideTailwind('text-primary')}`}
      >
        Page not found
      </h1>
    </div>
  );
};

export default NotFoundHeader;
